// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".window[data-v-b5162dda]{height:100%}.window.show-grid[data-v-b5162dda]{display:grid;grid-template-areas:\"body\" \"title\";grid-template-rows:auto 50px}.title[data-v-b5162dda]{grid-area:title;background-color:var(--wm-title-bg);border-top:1px solid var(--wm-title-border);height:100%;vertical-align:middle;padding:10px;overflow-x:auto;overflow-y:hidden}.body[data-v-b5162dda]{grid-area:body;height:100%;overflow:hidden}", ""]);
// Exports
module.exports = exports;
